import * as Scrivito from "scrivito";

const ContactWidget = Scrivito.provideWidgetClass("ContactWidget", {
  attributes: {
    contactPage: ["reference", { only: ["ContactPage"] }],
    contactReason: "string",
    isAltEmailDisplayed: ["enum", { values: ["yes", "no"] }],
    emailAddressToShow: "string",
    whichEmailAddress: [
      "enum",
      { values: ["primary", "secondary", "fromThisWidget"] },
    ],
    aspectRatio: ["enum", { values: ["1_1", "pass", "free"] }],
    direction: ["enum", { values: ["row", "column"] }],
    showSchema: "boolean",
    areaServed: "string",
    availableLanguage: "stringlist",
    contactType: "string",
    hoursAvailable: "string",
  },
  extractTextAttributes: ["contactReason", "emailAddressToShow"],
});

export default ContactWidget;
